import type { AllTableCriteria } from '@openx/types/tableCriteria.ts';
import { adjustPaginationCriteria } from '@openx/utils/lib/tableHelpers.ts';
import { type Dispatch, type SetStateAction, useCallback } from 'react';

export function useHandleListCriteriaOnCompleted<T extends Record<string, unknown>>(
  setCriteria: Dispatch<SetStateAction<AllTableCriteria<T>>>
) {
  return useCallback(
    (count?: number) => {
      setCriteria(previousCriteria => {
        if (typeof previousCriteria.pagination?.totalCount !== 'undefined' && typeof count === 'number') {
          return adjustPaginationCriteria(previousCriteria, count, false);
        }

        return previousCriteria;
      });
    },
    [setCriteria]
  );
}
